import React from 'react';
import styled from 'styled-components';

const LeftFlexHalf = styled.div`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
`;

export default LeftFlexHalf;
